import {Box, Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MultilineTextField from '../../../../shared-components/MultilineTextField';
import InfoHover from '../../../../shared-components/InfoHover';

function DescriptionSettings(
    {
        header,
        description,
        defaultDescription,
        onDescriptionChange,
        fieldLabel = 'Description',
        saveButtonText = 'Save description',
        rows,
        canBeEmpty = false,
        hover
    }) {
    const [text, setText] = useState(description);
    const actions = text !== defaultDescription && defaultDescription
        ? [
            {
                label: 'Revert to Default Description',
                onClick: () => setText(defaultDescription)
            }
        ]
        : [];

    useEffect(() => {
        setText(description);
    }, [description]);

    // AD-2696, AD-2712: only a box marked canBeEmpty (Dietary Needs) can be saved empty.
    const isEmptyRefused = !canBeEmpty && !text?.trim();

    return (
        <Box>
            {header && hover
                // Maria, 20 October 2026: on SIMS Lookups, the section's name with an 'i' saying where the text appears
                ? (
                    <Typography sx={{fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', gap: 0.5}}>
                        {header}
                        <InfoHover text={hover} testId={`hover-${header}`}/>
                    </Typography>
                )
                : header
                    ? <Typography variant="h6" fontWeight="bold" gutterBottom>{header}</Typography>
                    : null
            }
            <MultilineTextField
                label={hover ? null : fieldLabel}
                value={text}
                onChange={setText}
                actions={actions}
                rows={rows}
            />
            {description !== text && (
                <>
                    {isEmptyRefused && (
                        <Typography variant="body2" color="error" sx={{mt: 1}}>
                            Description cannot be empty
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        size={hover ? 'small' : 'medium'}
                        disabled={isEmptyRefused}
                        onClick={() => onDescriptionChange(text)}
                        sx={{
                            marginTop: hover ? 0 : 1,
                            backgroundColor: '#186BBE',
                            boxShadow: 'none',
                            width: { xs: '100%', sm: 'auto' },
                            '&:hover': {
                                backgroundColor: '#155FA7',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        {saveButtonText}
                    </Button>
                </>
            )}
        </Box>
    );
}

DescriptionSettings.propTypes = {
    header: PropTypes.string,
    description: PropTypes.string,
    defaultDescription: PropTypes.string,
    onDescriptionChange: PropTypes.func,
    fieldLabel: PropTypes.string,
    saveButtonText: PropTypes.string,
    rows: PropTypes.number,
    canBeEmpty: PropTypes.bool,
    hover: PropTypes.string
};

export default DescriptionSettings;
